<template>
    <div>
<!--        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="100px" size="mini">-->
            <el-row>{{title}}</el-row>
            <el-table
                    class="mrt5"
                    ref="table"
                    size="mini"
                    height="78"
                    border
                    :data="tableData"
                    style="width: 100%">
                <!--<el-table-column width="40px" align="center">
                    <template slot="header" slot-scope="scope">
                        <el-button class="addbtn" @click="addNew" slot="reference" ><i class="el-icon-plus"></i></el-button>
                    </template>
                    <template  slot-scope="scope">
                        <div class="iconminus">
                            <span class="minus" @click="delTraderResource(scope.row,scope.$index)" v-if="scope.row.i_id==0"><i class="el-icon-minus"></i></span>
                        </div>
                    </template>
                </el-table-column>-->
                <!--<el-table-column align="center" >
                    <template slot="header">
                        重量区间<el-button class="addbtn" @click="addNew" slot="reference" ><i class="el-icon-plus"></i></el-button>
                    </template>
                    <el-table-column align="center"
                                     v-for="(item,index) in arr"
                                     :key="index"
                                     :prop="item.prop">
                        <template slot="header" >
                            {{item.label}}
                            <el-button class="addbtn" style="width: 15px;height: 15px;border-radius: 50%" @click="delTraderResource(index)" v-if="arr.length>1"><i class="el-icon-minus" style="color: #f46161"></i></el-button>
                        </template>
                        <template slot-scope="scope">
&lt;!&ndash;                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+item.prop">&ndash;&gt;
                                <el-input  class="" v-model="scope.row.all[item.prop]" size="mini"></el-input>
&lt;!&ndash;                            </el-form-item>&ndash;&gt;
                        </template>
                    </el-table-column>
                </el-table-column>-->
                <el-table-column align="center" label="重量区间"  prop="vc_model">
                    <template slot-scope="scope">
<!--                        <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.vc_model'" :rules="formRules.vc_model">-->
                            <el-input  class="" v-model="scope.row.vc_model" size="mini"  @change="maxweight" ></el-input>
<!--                        </el-form-item>-->
                    </template>
                </el-table-column>
                <el-table-column align="center" label="单位" prop="unit" width="100"></el-table-column>
                <el-table-column align="center" label="是否含右"  prop="i_isContainR" width="100">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.i_isContainR" :true-label="1" :false-label="0" ></el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
        <el-row style="color: red;font-size: 12px;">请填入重量区间如：0-1;1-2;2-3;3-4;  注:必须以0作为开头,必须用分号" ; "作为分隔符,并以分号" ; "结束</el-row>
<!--        </el-form>-->
        <div class="pz" style="text-align: center;margin-top: 50px">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" :disabled="isSaved">
                保存
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "MbEdit",
        props:{
            bjmb:{
                type:Object,
                required:true,
            }
        },
        data() {
            var validateNum= (rule, value, callback) =>{
                // console.log(typeof value*1,"typeof",value*1)
                if (!Number.isFinite(value*1)) {
                    callback(new Error('请输入数字值'));
                }else {
                    // callback((value*1).toFixed(2));
                }
                // value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
            };
            return {
                /*formData:{
                    title:"",
                    tableData: [],
                },
                formRules:{
                    /!*f_minWeight:[{required:true,message:"请输入最小重量",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_maxWeight:[{required:true,message:"请输入最大重量",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],*!/
                },*/
                title:"",
                tableData:[/*
                    {vc_model:'',i_isContainR:1,unit:'吨'}
                */],
                // tableHeight:0,
                baseerp:"",
                isSaved:false,
                // addList:[],
                i_pid:'',
                /*number:1,
                weight:[],
                arr:[{prop:'weight1',
                    label:"区间1",}],
                allobj:{},
                obj:{weight1:""},*/
                tableId:0,
                bafter:"",

            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.i_pid=this.bjmb.i_id;
            /*this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });*/
            this.title=this.bjmb.vc_region;
            this.getDbTemplateList();
            // this.weight.push(this.number);
        },
        methods: {
            /*heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 330;
            },*/
            async getDbTemplateList(){
                let params={
                    i_pid:this.i_pid,
                };
                let res=await API.getDbTemplateList(params);
                if(res.code==1){
                        this.tableData.push(res.agreement);
                        this.tableData[0].unit='吨'
                    /*let value=res.agreement.vc_model.split(";")
                    let obj={};
                    let arrone=[];

                    for (let i=1;i<=value.length;i++){
                        let two={
                            prop:'weight'+i,
                            label:"区间"+i,
                        }
                        arrone.push(two);
                        let item={
                            ['weight'+i]:value[i-1],
                        }
                        obj={...obj,...item}
                        console.log(item,"item")
                    };
                    this.arr=arrone;
                    this.allobj={
                        all:obj,
                    };
                    let objother={
                        i_isContainR:res.agreement.i_isContainR,
                        unit:'吨'
                    };
                    this.tableData=[];
                    this.tableData.push({...this.allobj,...objother});
                    console.log(this.tableData[0].all,"this.value.length")*/
                    /*if (res.agreement.i_id!=0){
                        this.tableData=res.list;
                    }*/
                    // this.tableData.push(res.agreement);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }

            },
            /*addNew(){
                // console.log(this.tableData,"tableData")
                // this.arr=[];
                this.number++;
                this.allobj.all=this.tableData[0].all;
                let objList=[];
                objList=Object.values(this.allobj.all);
                let arrone=[];
                let obj={};
                let objother={i_isContainR:1,unit:'吨'};
                for (let i=1;i<=this.number;i++){
                    let two={
                        prop:'weight'+i,
                        label:"区间"+i,
                    }
                    arrone.push(two);
                    let item={
                        ['weight'+i]:objList[i-1],
                    }
                    obj={...obj,...item}
                    /!*let itemOther={
                        all:obj,
                    }*!/
                };
                this.arr=arrone;
                this.allobj={
                    all:obj,
                };
                this.tableData=[];
                this.tableData.push({...this.allobj,...objother});
                this.tableId=Math.random();
                // this.weight.push(this.number);
            },
            delTraderResource(index){
                this.number--;
                this.arr.splice(index,1);
                this.allobj.all=this.tableData[0].all;
                delete this.allobj.all['weight'+(index+1)];
                let objList=[];
                objList=Object.values(this.allobj.all);
                let objother={i_isContainR:0,unit:'吨'};
                let arrone=[];
                let obj={};
                for (let i=1;i<=this.number;i++){
                    let two={
                        prop:'weight'+i,
                        label:"区间"+i,
                    }
                    arrone.push(two);
                    let item={
                        ['weight'+i]:objList[i-1],
                    }
                    obj={...obj,...item}
                };
                this.arr=arrone;
                this.allobj={
                    all:obj,
                };
                this.tableData=[];
                this.tableData.push({...this.allobj,...objother});
                this.tableId=Math.random();
                console.log(this.tableData,"this.tableData",this.allobj.all)
                /!*this.$confirm('确定删除该区间?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    if (value.i_id!=0){
                        this.delList.push(value.i_id);
                    }
                    this.tableData.splice(index,1);
                })*!/
            },*/
           /* minweight(row,index){
                console.log(row)
                if(row.f_minWeight>row.f_maxWeight){
                    this.$message.error("最小重量不能大于最大重量")
                    row.f_minWeight=parseFloat(row.f_maxWeight).toFixed(5);
                    return;
                }else {
                    row.f_minWeight=parseFloat(row.f_minWeight).toFixed(5);
                    return;
                }
            },*/
            maxweight(){
                this.bafter="";
                this.tableData[0].vc_model=this.tableData[0].vc_model.replace(/；/g,";");
                if (this.tableData[0].vc_model[this.tableData[0].vc_model.length-1]!==';'){
                    this.$message.error("请已分号作为结束");
                    return
                };
                //console.log(this.tableData[0].vc_model.lastIndexOf(";"));
                let data=this.tableData[0].vc_model.split(";");
                    for (let i=0;i<data.length;i++){
                        let one=data[i].lastIndexOf("-");
                        // console.log(one,"one")
                        if(one!=-1){
                            let before=data[i].slice(0,one);
                            let after=data[i].slice(one+1);
                            // console.log(before,"before",after);
                            if (i==0&&before!=0){
                                this.$message.error("请按正确格式输入");
                                return
                            };
                            if (i>=1){
                                //console.log(before,"!==",this.bafter)
                                if(before!==this.bafter){
                                    // //console.log(before,"!==",this.bafter)
                                    this.$message.error("请注意输入区间");
                                    return
                                };
                            }

                            this.bafter=after;
                        }


                    }

               /* let i=before.lastIndexOf(";");
                let before=data.slice(0,index);

                let name=data.slice(i+1);*/
                // console.log(this.tableData[0].vc_model.lastIndexOf(";"),'==',data.length)
            },
            async saveBtn(ref){
                this.bafter="";
                this.tableData[0].vc_model=this.tableData[0].vc_model.replace(/；/g,";");
                if (this.tableData[0].vc_model[this.tableData[0].vc_model.length-1]!==';'){
                    this.$message.error("请已分号作为结束");
                    return
                };
                // console.log(this.tableData[0].vc_model.lastIndexOf(";"));
                let data=this.tableData[0].vc_model.split(";");
                for (let i=0;i<data.length;i++){
                    let one=data[i].lastIndexOf("-");
                    // console.log(one,"one")
                    if(one!=-1){
                        let before=data[i].slice(0,one);
                        let after=data[i].slice(one+1);
                        //console.log(before,"before",after);
                        if (i==0&&before!=0){
                            this.$message.error("请按正确格式输入");
                            return
                        };
                        if (i>=1){
                            //console.log(before,"!==",this.bafter)
                            if(before!==this.bafter){
                                // console.log(before,"!==",this.bafter)
                                this.$message.error("请注意输入区间");
                                return
                            };
                        }
                        this.bafter=after;
                    }
                }
                this.isSaved=true;
                if (this.tableData[0].vc_model??''!==''){
                    let saveParams={
                        i_pid:this.i_pid,
                        vc_model:this.tableData[0].vc_model,
                        i_isContainR:this.tableData[0].i_isContainR,
                    };
                    let res=await API.editDbTemplate(saveParams);
                    if(res.code==1){
                        this.isSaved=true;
                        this.cancel();
                    }else if (res.code == -2) {
                        this.isSaved=false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else {
                        this.isSaved=false;
                        this.$message.error(res.message);
                    }
                }

            },
            cancel(){
                this.$emit('closemb');
            },
        },
        /*beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },*/
    }
</script>

<style lang="scss">
    .flex{
        display: flex;
        align-items: center;
    }
    .el-icon-plus {
        font-size: 18px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .addbtn {
        border: none;
        padding: 0;
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
</style>